import { render } from "./QuanLyLuong.vue?vue&type=template&id=754a5d9c&scoped=true"
import script from "./QuanLyLuong.vue?vue&type=script&lang=js"
export * from "./QuanLyLuong.vue?vue&type=script&lang=js"

import "./QuanLyLuong.vue?vue&type=style&index=0&id=754a5d9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754a5d9c"]])

export default __exports__